import React from 'react';
import { Flame, Award, Target, Crown, Zap, Star } from 'lucide-react';
import { GamificationData } from '../data/mockData';
interface GamificationPanelProps {
  gamification: GamificationData;
}
export function GamificationPanel({
  gamification
}: GamificationPanelProps) {
  const getIcon = (iconName: string, earned: boolean) => {
    const props = {
      className: `w-6 h-6 ${earned ? 'text-white' : 'text-slate-500'}`
    };
    switch (iconName) {
      case 'Award':
        return <Award {...props} data-id="element-38" />;
      case 'Target':
        return <Target {...props} data-id="element-39" />;
      case 'Crown':
        return <Crown {...props} data-id="element-40" />;
      case 'Zap':
        return <Zap {...props} data-id="element-41" />;
      default:
        return <Star {...props} data-id="element-42" />;
    }
  };
  return <section className="bg-slate-800/60 border border-slate-700/50 rounded-xl p-6 h-full flex flex-col gap-6" data-id="element-43">
      <h2 className="text-lg font-semibold text-white flex items-center gap-2" data-id="element-44">
        <span className="w-1.5 h-5 bg-rose-500 rounded-full" data-id="element-45"></span>
        Achievements
      </h2>

      {/* Streaks */}
      <div data-id="element-46">
        <h3 className="text-xs uppercase tracking-wider text-slate-400 font-medium mb-3" data-id="element-47">
          Active Streaks
        </h3>
        <div className="grid grid-cols-4 gap-2" data-id="element-48">
          {[{
          label: 'Daily',
          value: gamification.streaks.daily,
          color: 'text-orange-500'
        }, {
          label: 'Pull',
          value: gamification.streaks.pull,
          color: 'text-blue-400'
        }, {
          label: 'Sub',
          value: gamification.streaks.submission,
          color: 'text-purple-400'
        }, {
          label: 'Lock',
          value: gamification.streaks.lock,
          color: 'text-emerald-400'
        }].map(streak => <div key={streak.label} className="bg-slate-900/50 rounded-lg p-2 flex flex-col items-center justify-center border border-slate-700/30" data-id="element-49">
              <Flame className={`w-5 h-5 mb-1 ${streak.value > 0 ? streak.color : 'text-slate-600'}`} data-id="element-50" />
              <span className="text-lg font-bold text-white leading-none mb-1" data-id="element-51">
                {streak.value}
              </span>
              <span className="text-[10px] text-slate-400 uppercase" data-id="element-52">
                {streak.label}
              </span>
            </div>)}
        </div>
      </div>

      {/* Badges */}
      <div data-id="element-53">
        <h3 className="text-xs uppercase tracking-wider text-slate-400 font-medium mb-3" data-id="element-54">
          Badges
        </h3>
        <div className="grid grid-cols-2 gap-3" data-id="element-55">
          {gamification.badges.map(badge => <div key={badge.name} className={`flex items-center gap-3 p-2 rounded-lg border ${badge.earned ? 'bg-gradient-to-br from-slate-800 to-slate-700 border-slate-600 shadow-[0_0_10px_rgba(255,255,255,0.05)]' : 'bg-slate-900/50 border-slate-800 opacity-60 grayscale'}`} data-id="element-56">
              <div className={`p-2 rounded-full ${badge.earned ? 'bg-indigo-500/20 shadow-[0_0_10px_rgba(99,102,241,0.3)]' : 'bg-slate-800'}`} data-id="element-57">
                {getIcon(badge.icon, badge.earned)}
              </div>
              <div className="flex flex-col" data-id="element-58">
                <span className="text-xs font-bold text-white leading-tight" data-id="element-59">
                  {badge.name}
                </span>
                <span className="text-[10px] text-slate-400" data-id="element-60">
                  {badge.earned ? 'Earned' : 'Locked'}
                </span>
              </div>
            </div>)}
        </div>
      </div>

      {/* Closer of the Week */}
      <div className="mt-auto pt-4 border-t border-slate-700/50" data-id="element-61">
        <div className="bg-gradient-to-r from-amber-500/10 to-orange-500/10 border border-amber-500/20 rounded-lg p-4 relative overflow-hidden" data-id="element-62">
          <div className="absolute -right-4 -top-4 text-amber-500/10" data-id="element-63">
            <Crown className="w-24 h-24" data-id="element-64" />
          </div>
          <div className="relative z-10" data-id="element-65">
            <h3 className="text-xs uppercase tracking-wider text-amber-400 font-bold mb-1 flex items-center gap-1" data-id="element-66">
              <Star className="w-3 h-3" data-id="element-67" /> Closer of the Week
            </h3>
            <div className="flex justify-between items-end" data-id="element-68">
              <div data-id="element-69">
                <div className="text-lg font-bold text-white" data-id="element-70">
                  {gamification.closerOfWeek.name}
                </div>
              </div>
              <div className="text-right" data-id="element-71">
                <div className="text-2xl font-black text-amber-400 leading-none" data-id="element-72">
                  {gamification.closerOfWeek.locks}
                </div>
                <div className="text-[10px] text-amber-200/70 uppercase" data-id="element-73">
                  Locks
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}